import { render, staticRenderFns } from "./TicketsInvoice.vue?vue&type=template&id=ee8ea85a&"
import script from "./TicketsInvoice.vue?vue&type=script&lang=js&"
export * from "./TicketsInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports